/* ORA: pagina collezione (sections/ora-collezione.liquid).
   Filtri e ordinamento nativi di Shopify: ogni scelta è un URL con parametri filter.* e sort_by,
   caricato con la Section Rendering API (?section_id=) e sostituito senza ricaricare la pagina.
   Il riquadro editoriale cambia misura e posto in base a colonne e numero di prodotti,
   così l'ultima riga della griglia non ha mai un prodotto da solo. */
(function () {
  'use strict';
  if (window.OraCollezione) return;

  var root = document.querySelector('[data-oz]');
  if (!root) return;
  var sid = root.getAttribute('data-oz-sid');
  var chiusi = {};
  var aperto = null, ritorno = null, richiesta = 0;

  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return [].slice.call((el || root).querySelectorAll(s)); }

  /* ===== riquadro editoriale senza orfani ===== */
  function colonne(g) {
    var ed = g.querySelector('[data-oz-edt]'), gc, gr;
    if (ed) { gc = ed.style.gridColumn; gr = ed.style.gridRow; ed.style.gridColumn = ''; ed.style.gridRow = ''; }
    var n = getComputedStyle(g).gridTemplateColumns.split(' ').filter(Boolean).length;
    if (ed) { ed.style.gridColumn = gc; ed.style.gridRow = gr; }
    return n;
  }
  function impagina() {
    var g = $('[data-oz-grid]'); if (!g) return;
    var ed = $('[data-oz-edt]', g); if (!ed) return;
    var c = colonne(g), n = $$(':scope > [data-oz-p]', g).length, r = n % c;
    if (c < 2 || !n) { ed.hidden = true; return; }
    var w, h;
    if (r === 0) { w = c === 4 ? 2 : c; h = c === 4 ? 2 : 1; } else { w = c - r; h = 1; }
    /* riga 2 se ci sono abbastanza prodotti per riempire le righe accanto, altrimenti riga 1 */
    var riga = 0;
    if (n >= c * (1 + h) - w * h) riga = 2;
    else if (n >= c * h - w * h) riga = 1;
    if (!riga) { ed.hidden = true; return; }
    ed.hidden = false;
    ed.style.gridColumn = (c - w + 1) + ' / span ' + w;
    ed.style.gridRow = riga + ' / span ' + h;
    ed.setAttribute('data-c', c);
    ed.setAttribute('data-full', w === c ? '1' : '0');
  }
  var ultime = 0;
  var ro = new ResizeObserver(function () {
    var g = $('[data-oz-grid]'); if (!g) return;
    var c = colonne(g); if (c !== ultime) { ultime = c; impagina(); }
  });
  function osserva() { var g = $('[data-oz-grid]'); ro.disconnect(); if (g) { ultime = colonne(g); ro.observe(g); } impagina(); }

  /* ===== fasce di prezzo: conteggi senza il filtro prezzo attivo ===== */
  function fasce() {
    var box = $('[data-oz-fasce-src]'); if (!box) return;
    carica(box.getAttribute('data-oz-fasce-src')).then(function (doc) {
      var s = doc && doc.querySelector('[data-oz-fasce]'); if (!s) return;
      var n = JSON.parse(s.textContent);
      $$('[data-oz-fascia]', box).forEach(function (a) {
        var k = +a.getAttribute('data-oz-fascia'), v = n[k];
        a.querySelector('.n').textContent = v;
        if (a.getAttribute('aria-checked') === 'true') return;
        if (v) { a.removeAttribute('aria-disabled'); a.setAttribute('href', a.getAttribute('data-oz-href')); }
        else { a.setAttribute('aria-disabled', 'true'); a.removeAttribute('href'); }
      });
    }).catch(function () {});
  }

  /* ===== Section Rendering API ===== */
  function urlSezione(u) { var x = new URL(u, location.origin); x.searchParams.set('section_id', sid); return x.toString(); }
  function carica(u) {
    return fetch(urlSezione(u), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    }).then(function (t) { return new DOMParser().parseFromString(t, 'text/html'); });
  }
  function pulito(u, tieniOrdine) {
    var x = new URL(u, location.origin), ora = new URLSearchParams(location.search);
    x.searchParams.delete('page'); x.searchParams.delete('section_id');
    if (tieniOrdine && !x.searchParams.get('sort_by') && ora.get('sort_by')) x.searchParams.set('sort_by', ora.get('sort_by'));
    ['preview_theme_id'].forEach(function (k) { if (ora.get(k) && !x.searchParams.get(k)) x.searchParams.set(k, ora.get(k)); });
    return x;
  }
  function vai(u, o) {
    o = o || {};
    var x = o.giaPulito ? u : pulito(u, o.tieniOrdine), id = ++richiesta, gw = $('.oz-gw');
    gw.setAttribute('aria-busy', 'true');
    return carica(x.toString()).then(function (doc) {
      if (id !== richiesta) return;
      var nuovo = doc.querySelector('[data-oz]');
      if (!nuovo) { location.href = x.toString(); return; }
      scambia(nuovo);
      if (!o.storia) history.pushState({ oz: 1 }, '', x.pathname + x.search);
      osserva(); fasce();
    }).catch(function () { location.href = x.toString(); });
  }
  function scambia(nuovo) {
    /* intestazione e chip non cambiano dentro la stessa collezione; barra, griglia e pannelli sì */
    ['.oz-tb', '.oz-gw', '.oz-fp--sort .oz-fp__b', '.oz-fp[data-oz-panel="filtri"] .oz-fp__h h2', '.oz-fp__f'].forEach(function (s) {
      var a = $(s), b = nuovo.querySelector(s); if (a && b) a.innerHTML = b.innerHTML;
    });
    var gw = $('.oz-gw'); gw.setAttribute('aria-busy', 'false');
    var fb = $('[data-oz-fbody]'), nb = nuovo.querySelector('[data-oz-fbody]');
    if (fb && nb) {
      var sc = fb.scrollTop, foc = document.activeElement, k = null;
      if (foc && fb.contains(foc)) { var g = foc.closest('[data-oz-fg]'); k = g ? [g.getAttribute('data-oz-fg'), foc.classList.contains('oz-fg__h') ? -1 : $$('.oz-opt', g).indexOf(foc)] : null; }
      fb.innerHTML = nb.innerHTML;
      $$('[data-oz-fg]', fb).forEach(function (g) { if (chiusi[g.getAttribute('data-oz-fg')]) g.querySelector('.oz-fg__h').setAttribute('aria-expanded', 'false'); });
      fb.scrollTop = sc;
      if (k) { var g2 = $('[data-oz-fg="' + k[0] + '"]', fb); var t = g2 && (k[1] < 0 ? g2.querySelector('.oz-fg__h') : $$('.oz-opt', g2)[k[1]]); if (t) t.focus({ preventScroll: true }); }
    }
    if (aperto) { var b = $('[data-oz-open="' + aperto.getAttribute('data-oz-panel') + '"]'); if (b) b.setAttribute('aria-expanded', 'true'); }
  }

  /* ===== carica altri: pagina successiva vera, aggiunta in coda ===== */
  function altri(a) {
    var box = a.closest('[data-oz-more-box]'), g = $('[data-oz-grid]');
    a.setAttribute('aria-busy', 'true'); a.textContent = 'Caricamento';
    var da = $$(':scope > [data-oz-p]', g).length;
    carica(a.href).then(function (doc) {
      doc.querySelectorAll('[data-oz-grid] > [data-oz-p]').forEach(function (li) { g.appendChild(document.importNode(li, true)); });
      var nb = doc.querySelector('[data-oz-more-box]'); if (nb) box.innerHTML = nb.innerHTML;
      impagina();
      var nuova = $$(':scope > [data-oz-p]', g)[da]; if (nuova) { var t = nuova.querySelector('.oc__t a'); if (t) t.focus({ preventScroll: true }); }
    }).catch(function () { location.href = a.href; });
  }

  /* ===== pannelli ===== */
  var veil = $('[data-oz-veil]');
  function apri(nome, da) {
    var el = $('[data-oz-panel="' + nome + '"]'); if (!el) return;
    if (aperto) chiudi(true);
    aperto = el; ritorno = da || document.activeElement;
    el.hidden = false; veil.hidden = false;
    document.documentElement.classList.add('oz-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('on'); veil.classList.add('on'); }); });
    if (da) da.setAttribute('aria-expanded', 'true');
    setTimeout(function () { var f = el.querySelector('[data-oz-close]'); if (f) f.focus({ preventScroll: true }); }, 60);
  }
  function chiudi(subito) {
    if (!aperto) return;
    var el = aperto; aperto = null;
    el.classList.remove('on'); veil.classList.remove('on');
    document.documentElement.classList.remove('oz-lock');
    $$('[data-oz-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { if (!el.classList.contains('on')) el.hidden = true; if (!aperto) veil.hidden = true; }, subito ? 0 : 340);
    if (ritorno && ritorno.isConnected && ritorno.focus) ritorno.focus({ preventScroll: true });
  }

  /* ===== ordina ===== */
  function srt() { return $('[data-oz-srt]'); }
  var sAct = 0;
  function voci() { return $$('li', srt()); }
  function segna() { voci().forEach(function (li, i) { li.classList.toggle('act', i === sAct); }); }
  function apriSort() { var s = srt(); s.classList.add('open'); s.querySelector('.oz-srt__b').setAttribute('aria-expanded', 'true'); sAct = Math.max(0, voci().findIndex(function (li) { return li.getAttribute('aria-selected') === 'true'; })); segna(); s.querySelector('.oz-lb').focus({ preventScroll: true }); }
  function chiudiSort(f) { var s = srt(); if (!s || !s.classList.contains('open')) return; s.classList.remove('open'); var b = s.querySelector('.oz-srt__b'); b.setAttribute('aria-expanded', 'false'); if (f) b.focus({ preventScroll: true }); }
  function ordina(v) {
    var x = new URL(location.href); x.searchParams.delete('page');
    if (v) x.searchParams.set('sort_by', v); else x.searchParams.delete('sort_by');
    chiudiSort(); chiudi(true); vai(x, { giaPulito: true });
  }

  /* ===== eventi ===== */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var o = t.closest('[data-oz-open]'); if (o) { apri(o.getAttribute('data-oz-open'), o); return; }
    if (t.closest('[data-oz-close]')) {
      chiudi();
      if (t.closest('[data-oz-show]')) { var tb = $('.oz-tb'), y = tb.getBoundingClientRect().top + scrollY - (parseInt(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0); if (scrollY > y) scrollTo({ top: y, behavior: 'smooth' }); }
      return;
    }
    if (t === veil) { chiudi(); return; }
    var h = t.closest('.oz-fg__h');
    if (h) { var g = h.closest('[data-oz-fg]').getAttribute('data-oz-fg'), on = h.getAttribute('aria-expanded') === 'true'; h.setAttribute('aria-expanded', String(!on)); chiusi[g] = on; return; }
    var a = t.closest('a[data-oz-url]');
    if (a) { e.preventDefault(); if (a.hasAttribute('href')) vai(a.href, { tieniOrdine: true }); return; }
    var m = t.closest('a[data-oz-more]'); if (m) { e.preventDefault(); altri(m); return; }
    if (t.closest('[data-oz-su]')) { var top = root.getBoundingClientRect().top + scrollY; scrollTo({ top: Math.max(0, top - 80), behavior: 'smooth' }); var h1 = $('#oz-h'); if (h1) { h1.tabIndex = -1; h1.focus({ preventScroll: true }); } return; }
    var sb = t.closest('.oz-srt__b'); if (sb) { e.stopPropagation(); if (srt().classList.contains('open')) chiudiSort(); else apriSort(); return; }
    var li = t.closest('[data-oz-sort]'); if (li) { ordina(li.getAttribute('data-oz-sort')); return; }
    var c = t.closest('a[data-oz-chip]');
    if (c) {
      /* i filtri e l'ordine scelti restano quando si cambia categoria */
      var q = new URLSearchParams(location.search), x = new URL(c.href), n = 0;
      q.forEach(function (v, k) { if (k.indexOf('filter.') === 0 || k === 'sort_by') { x.searchParams.append(k, v); n++; } });
      if (n) { e.preventDefault(); location.href = x.toString(); }
    }
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-oz-srt]')) chiudiSort(); });
  root.addEventListener('keydown', function (e) {
    var a = e.target.closest && e.target.closest('a.oz-opt');
    if (a && e.key === ' ') { e.preventDefault(); a.click(); return; }
    var lb = e.target.closest && e.target.closest('[data-oz-srt] .oz-lb');
    if (lb) {
      var n = voci().length;
      if (e.key === 'ArrowDown') { e.preventDefault(); sAct = (sAct + 1) % n; segna(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); sAct = (sAct + n - 1) % n; segna(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ordina(voci()[sAct].getAttribute('data-oz-sort')); }
      else if (e.key === 'Escape') { e.preventDefault(); chiudiSort(true); }
      else if (e.key === 'Tab') chiudiSort();
    }
  });
  veil.addEventListener('click', function () { chiudi(); });
  document.addEventListener('keydown', function (e) {
    if (!aperto) return;
    if (e.key === 'Escape') { e.preventDefault(); chiudi(); return; }
    if (e.key === 'Tab') {
      var f = $$('button:not(:disabled),[href],[tabindex]:not([tabindex="-1"])', aperto).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  window.addEventListener('popstate', function () { vai(new URL(location.href), { giaPulito: true, storia: true }); });

  function titolo() { var h = $('#oz-h'); if (h) document.title = h.textContent.trim() + ' – ORA®'; }
  osserva(); fasce(); titolo();
  window.OraCollezione = { impagina: impagina, vai: vai };
})();
